/* eslint-disable radix */
/* eslint-disable @sailor/i18n-no-country-codes */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable multiline-comment-style */
/* eslint-disable @sailor/base-prefer-boolean-function */
/* eslint-disable @sailor/base-getter-setter-best-practices */
import React, { useEffect, useState, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import Button from '@roo/roo/Button'
import { useTranslation } from '@sailor/i18n-web'
import { useRequest } from 'ahooks'
import { getI18nTime, replaceMoneySymbol } from '@/common/utils/i18nFuncs'
import CommonTable from '@/components/CommonTable'
import { fetchOrderList, fetchOrderDownloadExcel } from './utils/api'
import {  OrderApiItem } from './types'
import { FormPro } from '@roo/roo'
import Input from '@roo/roo/Input'
import Selector from '@roo/roo/Selector'
import { RegionDateRangePicker } from '@/components/RegionDatePicker'
import RuleDetail from './components/RuleDetail'
import ReceiptDownload from './components/ReceiptDownload'
import useOrderMaps from './utils/useOrderMaps'
import OrderStatusTag from './components/OrderStatusTag'
import { getDateTimePattern, languageOptions } from '@/common/utils/i18n'

import { getLanguage } from '@/common/utils/i18n'
import { failToast, warningToast } from '@/common/utils/toast'
import { IOrderDownloadExcelParams } from './types'

import {
  queryExportStatus,
} from '@/pages/staff/common/api'
import { createPolling, downloadFile } from '@/common/utils'
import entInfoAtom from '@/common/recoil/atom/entInfoAtom'
import DropMenu from '@roo/roo/DropMenu'
import Icon from '@roo/roo/Icon'
import useRuleConfig from '@/common/recoil/atom/ruleConfigAtom'
import styles from './index.module.less'


// 下拉菜单宽度配置 - 按语言区分
const DROPDOWN_WIDTH_MAP = {
  en: 176,
  'zh-HK': 142,
} as const

// 操作列宽度配置 - 按语言和是否显示下载凭证区分
const OPERATION_COLUMN_WIDTH_MAP = {
  // 有下载凭证按钮时的宽度
  withReceipt: {
    en: 230,
    'zh-HK': 150,
  },
  // 没有下载凭证按钮时的宽度
  withoutReceipt: {
    en: 110,
    'zh-HK': 90,
  },
} as const

// 获取下拉菜单宽度的辅助函数
const getDropdownWidth = () => {
  const lang = getLanguage()
  return DROPDOWN_WIDTH_MAP[lang as keyof typeof DROPDOWN_WIDTH_MAP] ?? DROPDOWN_WIDTH_MAP['zh-HK']
}

// 获取操作列宽度的辅助函数
const getOperationColumnWidth = (hasReceipt: boolean) => {
  const lang = getLanguage()
  const widthMap = hasReceipt ? OPERATION_COLUMN_WIDTH_MAP.withReceipt : OPERATION_COLUMN_WIDTH_MAP.withoutReceipt
  return widthMap[lang as keyof typeof widthMap] ?? widthMap['zh-HK']
}

export default () => {
  const { t, ready } = useTranslation()
  const [form] = FormPro.useForm()
  const [searchParams] = useSearchParams()
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 20 })
  const [showMoreFilters, setShowMoreFilters] = useState(false)
  const { showPickup } = useRuleConfig() || {}
  const { data: ruleListRes, loading, run } = useRequest(() => fetchOrderList({ ...pageInfo, ...getFormData() }), { manual: true })
  const [isDownLoading, setIsDownLoading] = useState(false)
  const { payTypeMap, statusMap, userGetModeMap } = useOrderMaps()
  const entInfo = entInfoAtom.useData()
  // 定义下拉菜单内容
  const menu = languageOptions.map(option => ({
    label: option.label,
    onClick: () => handleExport(option.value),
  }))
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [isSelectAllPages, setIsSelectAllPages] = useState(false)

  const totalOrderCount = ruleListRes?.totalCount || 0

  // 「更多筛选」区域展示的字段总数：5个固定字段 + 按开关动态增减
  const collapsedFilterCount = useMemo(() => {
    let count = 5 // 订单状态、支付方式、取货方式、下单时间、备注
    if (entInfo?.costCenterEnabled) count++
    if (entInfo?.expenseCodeEnabled) count++
    return count
  }, [entInfo?.costCenterEnabled, entInfo?.expenseCodeEnabled])

  useEffect(run, [pageInfo]) // 分页信息改变时,重新请求数据

  // 处理从 URL 参数传入的订单号 - 直接打开详情抽屉
  const directOpenOrderId = searchParams.get('bizOrderId')

  function getFormData () {
    const { feTimeRange, ...rest } = form.getFieldsValue()
    const [createTimeStart, createTimeEnd] = feTimeRange || []
    return { ...rest, createTimeStart, createTimeEnd }
  }

  const totalSelectedCount = useMemo(() => {
    if (isSelectAllPages) {
      return totalOrderCount
    }
    return selectedRowKeys.length
  }, [isSelectAllPages, selectedRowKeys, totalOrderCount])

  const rowSelection = useMemo(() => {
    const currentPageKeys = ruleListRes?.result?.map(item => item.id) || []
    let currentSelectedKeys: React.Key[] = []

    if (isSelectAllPages) {
      // 全选全部模式
      currentSelectedKeys = currentPageKeys.filter(key => currentPageKeys.includes(key))
    } else {
      // 单选模式
      currentSelectedKeys = selectedRowKeys.filter(key => currentPageKeys.includes(key))
    }

    return {
      type: 'checkbox' as const,
      selectedRowKeys: currentSelectedKeys,
      getCheckboxProps: (record: OrderApiItem) => ({
        // 当"全选全部"时，禁用所有单选框
        disabled: isSelectAllPages,
      }),
      // 处理单选/多选变化
      onChange: (selectedKeys: React.Key[], selectedRows: OrderApiItem[]) => {
        const currentPageKeysSet = new Set(currentPageKeys)
        // 局部选择模式下的操作 (单选/多选)
        // -----------------------------------------------------------
        // 1. 移除当前页的所有 key
        const otherPageKeys = selectedRowKeys.filter(key => !currentPageKeysSet.has(key))
        // 2. 添加当前页新选中的 key
        setSelectedRowKeys([...otherPageKeys, ...selectedKeys])
      },
    }
  }, [selectedRowKeys, isSelectAllPages, ruleListRes?.result, pageInfo.pageNo, totalOrderCount])

  // 统一的清除选择状态的函数
  const clearSelectionStates = () => {
    setIsSelectAllPages(false)
    setSelectedRowKeys([])
  }

  const handleToggleSelectAllPages = () => {
    const newState = !isSelectAllPages
    setIsSelectAllPages(newState)
    if (newState) {
      // 开启全选时，必须清空所有局部状态和排除项，确保从"干净"的状态开始。
      setSelectedRowKeys([])
    }
  }

  const handleDownload = async (params: IOrderDownloadExcelParams) => {
    if (isDownLoading) return
    try {
      setIsDownLoading(true)
      const token: any = await fetchOrderDownloadExcel(params)
      if (token) {
        createPolling({
          requestFunction: async () => queryExportStatus({ token }),
          checkSuccess: (response) => response.data.code === 30,
          onSuccess: (param) => {
            const { downLoadUrl: fileUrl } = param.data || {}
            setIsDownLoading(false)
            if (fileUrl) {
              downloadFile({ url: fileUrl })
            }
          },
          checkError: (response) => response?.success === false || response?.data?.code === 40,
          onError: (error) => {
            if (error?.success && error.data.code === 40) {
              failToast(error.data.message)
            }
            setIsDownLoading(false)
          },
        })
      }
    } catch (error) {
      setIsDownLoading(false)
      console.log(error)
    }
  }

  const handleExport = (locale) => {
    if (isDownLoading) {
      return
    }
    // 判断是否全选
    const exportByCondition = isSelectAllPages
    let countToExport = totalSelectedCount

    let exportKeys: React.Key[] = []
    let exportPages: number[] = []

    if (exportByCondition) {
      countToExport = totalOrderCount
    } else {
      // 保持 ID 为字符串，避免大数字精度丢失
      exportKeys = selectedRowKeys.filter(key => typeof key === 'string' && key.length > 0)
      if (exportPages.length > 0) {
        countToExport = (exportPages.length * pageInfo.pageSize) + exportKeys.length
        // 如果只有单选 keys，使用单选 keys 数量
      } else {
        countToExport = exportKeys.length
      }
    }

    // 前置拦截：检查下载数量是否超过限制（单次最多下载100000条）
    const MAX_DOWNLOAD_COUNT = 100000
    if (countToExport > MAX_DOWNLOAD_COUNT) {
      warningToast(t('e_order_download_limited', '單次下載訂單數量已超過系統上限 10 萬張，請調整數量'))
    }

    const formData = getFormData()
    let exportData: IOrderDownloadExcelParams = {
      locale,
      orderQueryParam: {
        ...formData,
        orderIds: exportKeys,
        // 传递成本中心/费用代码过滤参数（T040）
        costCenterName: formData.costCenterName,
        expenseCode: formData.expenseCode,
      },
    }
    handleDownload(exportData)
  }

  // 只要 selectedRowKeys，就认为有选中
  const hasSelectedOrders = isSelectAllPages || selectedRowKeys.length > 0

  const columns: any[] = useMemo(() => [
    {
      title: t('e_pc_order_time', '下单时间'), dataIndex: 'createdTime',
      width: 220,
      render: (time:number) => getI18nTime(time, getDateTimePattern()),
    },
    {
      title: t('e_pc_business_order_number', '业务订单号'),
      dataIndex: 'bizOrderId',
      width: 200,
      render: (bizOrderId: string) => (
        <span className="truncate" title={bizOrderId}>{bizOrderId}</span>
      ),
    },
    {
      title: t('e_pc_employee_name2', '员工姓名'),
      dataIndex: 'staffName',
      width: 180,
      render: (staffName: string) => (
        <span className="truncate" title={staffName}>{staffName}</span>
      ),
    },
    {
      title: t('e_pc_employee_email', '员工邮箱'),
      dataIndex: 'staffEmail',
      width: 220,
      render: (staffEmail: string) => (
        <span className="truncate" title={staffEmail}>{staffEmail}</span>
      ),
    },
    {
      title: t('e_pc_order_status', '订单状态'),
      dataIndex: 'bizOrderStatus',
      width: 150,
      render: (status: number) => <OrderStatusTag status={status}/>,
    },
    {
      title: t('e_pc_order_amount', '订单金额'),
      dataIndex: 'orderAmount',
      width: 130,
      render: (orderAmount: OrderApiItem['orderAmount']) => (
        <span className="whitespace-nowrap">
          {replaceMoneySymbol(orderAmount?.displayText || '--')}
        </span>
      ),
    },
    {
      title: t('e_pc_actual_payment_amount', '实付金额'),
      dataIndex: 'realPayAmount',
      width: 120,
      render: (realPayAmount: OrderApiItem['realPayAmount']) => (
        <span className="whitespace-nowrap" >
          {replaceMoneySymbol(realPayAmount?.displayText || '--')}
        </span>
      ),
    },
    {
      title: t('e_pc_payment_method', '支付方式'),
      dataIndex: 'payType',
      width: 200,
      render: (status: OrderApiItem['payType']) => <span> {payTypeMap[status] || '--'} </span>,
    },
    {
      title: t('e_pc_pickup_method', '取货方式'),
      dataIndex: 'userGetMode',
      render: (userGetMode: string) => (userGetModeMap[userGetMode]) || '--',
      width: 120,
    },
    // T038: 按开关新增「成本中心」列
    entInfo?.costCenterEnabled && {
      title: t('e_pc_cost_center_tab', '成本中心'),
      dataIndex: 'costCenterName',
      width: 160,
      render: (costCenterName: string) => (
        <span className="truncate" title={costCenterName}>{costCenterName || '--'}</span>
      ),
    },
    // T038: 按开关新增「费用代码」列
    entInfo?.expenseCodeEnabled && {
      title: t('e_pc_expense_code_label', '费用代码'),
      dataIndex: 'expenseCode',
      width: 140,
      render: (expenseCode: string) => (
        <span className="truncate" title={expenseCode}>{expenseCode || '--'}</span>
      ),
    },
    // T038: 按开关新增「费用备注」列
    entInfo?.expenseCodeEnabled && {
      title: t('e_pc_expense_remark', '费用备注'),
      dataIndex: 'expenseRemark',
      width: 160,
      render: (expenseRemark: string) => (
        <span className="truncate" title={expenseRemark}>{expenseRemark || '--'}</span>
      ),
    },
    { title: t('e_pc_operation', '操作'), dataIndex: 'bizOrderId',
      fixed: 'right',
      _width: getOperationColumnWidth(!!entInfo?.receiptEmailSendConfig),
      get width () {
        return this._width
      },
      set width (value) {
        this._width = value
      },
      render: (bizOrderId: string, record: OrderApiItem) => (
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <Button type="brand-text">
            <RuleDetail bizOrderId={parseInt(bizOrderId)} />
          </Button>
          {
            entInfo?.receiptEmailSendConfig
              ? <ReceiptDownload bizId={bizOrderId} bizOrderStatus={record.bizOrderStatus} payType={record.payType}/>
              : null
          }
        </div>
      ),
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [ready, entInfo?.costCenterEnabled, entInfo?.expenseCodeEnabled, entInfo?.receiptEmailSendConfig, showPickup, payTypeMap, statusMap, userGetModeMap])

  // 独立的直接打开订单详情组件
  const DirectOrderDetail = directOpenOrderId ? (
    <RuleDetail
      bizOrderId={Number(directOpenOrderId)}
      defaultOpen
      hideText
    />
  ) : null

  return (
    <div className="page-content" style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
      {DirectOrderDetail}
      <div style={{ paddingBottom: '6px' }}>
        <div className="page-title">
          {t('e_pc_order_query', '订单查询')}
        </div>
        <FormPro form={form} name="search_form"
          style={{ marginTop: '24px' }}
          initialValues={{ remember: true }}
          layout="vertical"
          labelCol={{ span: 12 }}
          wrapperCol={{ span: 12 }}
          size="small"
          onFinish={() => {
            clearSelectionStates()
            setPageInfo((old) => ({ ...old, pageNo: 1 }))
          }}
        >
          {/* Grid 4 列布局：所有行字段天然对齐 */}
          <div className={styles.filterGrid} style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px 12px', alignItems: 'end', paddingBottom: 12 }}>
            {/* 第一行：邮箱 / 员工姓名 / 订单号 / 订单状态（收起时第4列为按钮，展开时为订单状态） */}
            <FormPro.Item label={t('e_pc_email', '邮箱')} name="staffEmail" style={{ marginBottom: 0 }}>
              <Input placeholder={t('e_pc_email_input')} />
            </FormPro.Item>
            <FormPro.Item label={t('e_pc_employee_name2', '员工姓名')} name="staffName" style={{ marginBottom: 0 }}>
              <Input placeholder={t('e_pc_employee_name_input')} />
            </FormPro.Item>
            <FormPro.Item label={t('e_pc_order_number', '订单号')} name="bizOrderId" style={{ marginBottom: 0 }}>
              <Input placeholder={t('e_pc_order_number')} />
            </FormPro.Item>
            {/* 收起时：按钮区；展开时：订单状态 */}
            {!showMoreFilters ? (
              <FormPro.Item style={{ marginBottom: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '12px' }}>
                  <Button
                    type="text"
                    size="normal"
                    style={{ color: '#000000', padding: '0 4px' }}
                    onClick={() => setShowMoreFilters(v => !v)}
                  >
                    <span className={styles.filterToggleLabel}>{t('e_pc_filter_expands', '展开')}</span>
                    {collapsedFilterCount > 0 && (
                      <span className={styles.filterCountBadge}>{collapsedFilterCount}</span>
                    )}
                    <Icon name="chevron-down" style={{ fontSize: 20, color: '#000000' }} />
                  </Button>
                  <Button type="hollow" size="normal" htmlType="button"
                    onClick={() => {
                      form.resetFields()
                      clearSelectionStates()
                      setPageInfo((old) => ({ ...old, pageNo: 1 }))
                    }}
                  >
                    {t('e_pc_reset', '重置')}
                  </Button>
                  <Button type="brand" size="normal" htmlType="submit" className="btn-dark">
                    {t('e_pc_aquire', '查询')}
                  </Button>
                </div>
              </FormPro.Item>
            ) : (
              <FormPro.Item label={t('e_pc_order_status', '订单状态')} name="bizOrderStatus" style={{ marginBottom: 0 }}>
                <Selector clearable options={Object.entries(statusMap).map(item => ({ value: item[0], label: item[1] }))} />
              </FormPro.Item>
            )}

            {/* 第二行（展开后）：支付方式 / 取货方式 / 下单时间(span 2) */}
            {showMoreFilters && (
              <>
                <FormPro.Item label={t('e_pc_payment_method', '支付方式')} name="payType" style={{ marginBottom: 0 }}>
                  <Selector clearable options={Object.entries(payTypeMap).map(item => ({ value: item[0], label: item[1] }))} />
                </FormPro.Item>
                <FormPro.Item label={t('e_pc_pickup_method', '取货方式')} name="userGetMode" style={{ marginBottom: 0 }}>
                  <Selector clearable
                    options={[
                      { value: 'delivery', label: t('e_pc_delivery', '外卖') },
                      showPickup !== false && { value: 'pickup', label: t('e_pc_pickup', '自提') },
                    ].filter(item => item)}
                  />
                </FormPro.Item>
                <FormPro.Item label={t('e_pc_order_time', '下单时间')} name="feTimeRange" style={{ marginBottom: 0, gridColumn: 'span 2' }}>
                  <RegionDateRangePicker clearable style={{ width: '100%' }} />
                </FormPro.Item>
              </>
            )}

            {/* 展开后第三行：备注（始终）+ 成本中心（costCenterEnabled）+ 费用代码（expenseCodeEnabled）+ 按钮区 */}
            {showMoreFilters && (
              <>
                {/* 备注：始终展示 */}
                <FormPro.Item label={t('e_pc_remark', '备注')} name="remark" style={{ marginBottom: 0 }}>
                  <Input placeholder={t('e_pc_please_input_remark', '请输入备注信息')} />
                </FormPro.Item>
                {/* 成本中心：costCenterEnabled=true 时展示 */}
                {entInfo?.costCenterEnabled ? (
                  <FormPro.Item label={t('e_pc_cost_center_tab', '成本中心')} name="costCenterName" style={{ marginBottom: 0 }}>
                    <Input placeholder={t('e_pc_cost_center_placeholder', '请输入成本中心')} />
                  </FormPro.Item>
                ) : <div />}
                {/* 费用代码：expenseCodeEnabled=true 时展示 */}
                {entInfo?.expenseCodeEnabled ? (
                  <FormPro.Item label={t('e_pc_expense_code_label', '费用代码')} name="expenseCode" style={{ marginBottom: 0 }}>
                    <Input placeholder={t('e_pc_expense_code_search_placeholder', '请输入费用代码')} />
                  </FormPro.Item>
                ) : <div />}
                {/* 按钮区：第4列右对齐 */}
                <FormPro.Item style={{ marginBottom: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '12px' }}>
                    <Button
                      type="text"
                      size="normal"
                      style={{ color: '#000000', padding: '0 4px' }}
                      onClick={() => setShowMoreFilters(v => !v)}
                    >
                      <span className={styles.filterToggleLabel}>{t('e_pc_filter_folds', '收起')}</span>
                      <Icon name="chevron-up" style={{ fontSize: 20, color: '#000000' }} />
                    </Button>
                    <Button type="hollow" size="normal" htmlType="button"
                      onClick={() => {
                        form.resetFields()
                        clearSelectionStates()
                        setPageInfo((old) => ({ ...old, pageNo: 1 }))
                      }}
                    >
                      {t('e_pc_reset', '重置')}
                    </Button>
                    <Button type="brand" size="normal" htmlType="submit" className="btn-dark">
                      {t('e_pc_aquire', '查询')}
                    </Button>
                  </div>
                </FormPro.Item>
              </>
            )}
          </div>
        </FormPro>
      </div>

      {/* 选择全部订单 + 已选择X条 + 导出订单：搜索区与表格之间独立一行 */}
      {(ruleListRes?.result && ruleListRes.result.length > 0) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Button
            type="brand-text"
            onClick={handleToggleSelectAllPages}
          >
            {isSelectAllPages ? t('e_pc_cancel_select_all_order', '取消选择全部订单') : t('e_pc_select_all_order', '选择全部订单')}
          </Button>
          {totalSelectedCount
            ? <Button type="text" style={{ color: '#666666' }}>
              {t('e_pc_selected_all_order_amount', {
                count: <span style={{ color: '#666666', fontWeight: 600 }}>{totalSelectedCount}</span>,
                pluralCount: totalSelectedCount,
                defaultValue: `已选择${totalSelectedCount}条订单`,
              })}
            </Button>
            : null
          }
          <div style={{ marginLeft: 'auto' }}>
            <DropMenu
              menu={menu}
              disabled={!hasSelectedOrders || isDownLoading}
              style={{ width: getDropdownWidth() }}
            >
              <Button
                disabled={!hasSelectedOrders || isDownLoading}
                style={{ borderRadius: 6 }}
                loading={isDownLoading}
              >
                {!isDownLoading && <Icon name="download" /> || null}
                {t('e_pc_download_order', '导出订单')}
                <Icon name="chevron-down" />
              </Button>
            </DropMenu>
          </div>
        </div>
      )}

      <CommonTable
        rowKey="id"
        columns={columns}
        data={ruleListRes?.result || []}
        loading={loading}
        rowSelection={rowSelection}
        pagination={{
          total: totalOrderCount,
          pageSize: pageInfo.pageSize,
          currentPage: pageInfo.pageNo,
          onChange: (pageNo: number, pageSize: number) => setPageInfo({ pageNo, pageSize }),
        }}
        style={{ marginTop: 20 }}
      />
    </div>
  )
}
